<app-admin-header
  style="width: 100%"
  [header]="header"
  [links]="links"
  [breadcrumbs]="(showAddUserModal) ? addUserBreadcrumbs : breadcrumbs"
  [stats]="[]"
></app-admin-header>
<p-messages [(value)]="messages" [enableService]="false"></p-messages>
<app-assign-users
  [fromMS]="true"
  [selectionData]="addedUsers"
  (selectedUsersList)="addResponsibles($event)"
  [userFetchUrl]="'user'"
  *ngIf="showAddUserModal"
></app-assign-users>
<app-skelitions [hidden]="!skelition" [value]="2"></app-skelitions>
<section
  class="container-fluid v4-bg-img py-5 33333"
  *ngIf="!skelition && !showAddUserModal"
>
  <div class="container ms-pg-structure">
    <div class="white-box">
      <div class="row my-4">
        <div class="col-md-4 col-12">
          <div class="column mx-4 my-2">
            <h5 class="medium-h">{{ "Project Name" | translator }}</h5>
            <input
              type="text"
              [(ngModel)]="project.name"
              class="form-control ms-input"
              [placeholder]="'Project Name' | translator"
              aria-describedby="projectname"
            />
          </div>
        </div>
        <div class="col-md-5 col-12 p-0">
          <div class="d-flex p-l-r-2rem w-100">
            <div class="column mx-1 my-2 width-100">
              <h5 class="medium-h">{{ "Start Date" | translator }}</h5>
              <p-calendar
                #startDate
                class="form-control ms-input w-100"
                [styleClass]="'calender-hide'"
                placeholder="dd/mm/yyyy"
                [minDate]="minDate"
                [(ngModel)]="project.startDate"
              ></p-calendar>
            </div>
            <div class="column mx-1 my-2 width-100">
              <h5 class="medium-h">{{ "End Date" | translator }}</h5>
              <p-calendar
                [minDate]="startDate.value"
                class="form-control ms-input w-100"
                [styleClass]="'calender-hide'"
                placeholder="dd/mm/yyyy"
                [(ngModel)]="project.endDate"
              ></p-calendar>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-12">
          <div class="column mx-4 my-2">
            <h5 class="medium-h">{{ "Tag" | translator }}</h5>
            <p-dropdown
                [placeholder]="'Select Vendor' | translator"
                [filter]="true"
                filterBy="label"
                [options]="allTags"
                [ngClass]="'ms-dropdown-pg-3'"
                optionValue="_id"
                optionLabel="label"
                [(ngModel)]="project.tag"
              >
            </p-dropdown>
          </div>
        </div>
        <div class="col-md-12 col-12">
          <div class="column mx-4 my-2">
            <h5 class="medium-h">{{ "Project Description" | translator }}</h5>
            <input
              type="text"
              class="form-control ms-input"
              [placeholder]="'Description' | translator"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              [(ngModel)]="project.description"
            />
          </div>
        </div>
        <div class="row col-md-12 col-12">
          <div class="col-md-4 col-12">
            <div class="column mx-4 my-2">
              <h5 class="medium-h mb-3">{{ "Vendor" | translator }}</h5>
              <div>
                <p-dropdown
                  [placeholder]="'Select Vendor' | translator"
                  [filter]="true"
                  filterBy="name.first,name.middle,name.last"
                  [options]="externalVendors"
                  [ngClass]="'ms-dropdown-pg-3'"
                  optionValue="_id"
                  optionLabel="name"
                  [(ngModel)]="project.vendorCompanyId"
                >
                </p-dropdown>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <div class="column mx-4 my-2">
              <h5 class="medium-h">{{ "Internal PM Email" | translator }}</h5>
              <div>
                <input
                  class="form-control ms-input"
                  [(ngModel)]="project.internalPMEmail"
                />
              </div>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <div class="column mx-4 my-2">
              <h5 class="medium-h">{{ "Factor cut %" | translator }}</h5>
              <div>
                <input
                  [maxLength]="3"
                  (keypress)="numberOnly($event, true)"
                  class="form-control ms-input"
                  [(ngModel)]="project.factorCutOffPercentage"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row px-4">
        <div class="col-md-4 col-12">
          <div class="grey-box">
            <div class="d-flex">
              <div class="width-100">
                <h4 class="medium-h my-2">{{ "Channels" | translator }}</h4>
              </div>
              <div>
                <h4 class="medium-h mx-2 my-2">{{ "Visits" | translator }}</h4>
              </div>
            </div>

            <div class="mob-flex-wrap" *ngFor="let channel of channels">
              <div class="width-100">
                <div class="white-box-check">
                  <div class="d-flex align-items-center">
                    <div class="d-flex">
                      <div
                        class="ms-check-box"
                        (click)="addRemoveChannel(channel)"
                      >
                        <i
                          *ngIf="channelSelected(channel)"
                          class="pi pi-check"
                        ></i>
                        <i
                          *ngIf="!channelSelected(channel)"
                          class="pi pi-x"
                        ></i>
                      </div>
                    </div>
                    <div class="d-flex flex-wrap">
                      <div class="ms-check-box-name">
                        {{ channel.name | translator }}
                        {{
                          channel.name == "Branches"
                            ? ("(Visit per branch)" | translator)
                            : ""
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="white-box-visits padding-1">
                  <div class="d-flex align-items-center">
                    <div class="d-flex flex-wrap">
                      <input
                        (keypress)="numberOnly($event, false)"
                        class="form-control ms-input"
                        [(ngModel)]="channel.visitCount"
                        (ngModelChange)="updateChannelCount(channel)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-end">
              <div
                class="ms-plus-btn ms-ml-05 my-3"
                (click)="showAddChannel = true"
              >
                <i class="pi pi-plus-circle"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-12">
          <div class="grey-box">
            <div class="d-flex align-items-end">
              <div class="column width-100">
                <h5 class="medium-h my-2">
                  {{ "Project Goals" | translator }}
                </h5>
                <input
                  type="text"
                  [(ngModel)]="goalText"
                  class="form-control ms-input-white"
                  [placeholder]="'Goal' | translator"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                />
              </div>
              <div class="ms-plus-btn mx-2" (click)="addGoal()">
                <i class="pi pi-plus-circle"></i>
              </div>
            </div>
            <div class="ms-my-top-bottom-5">
              <div
                class="white-box-check"
                *ngFor="let goal of project.goal; let i = index"
              >
                <div class="custom-flex-pg-3">
                  <div class="d-flex align-items-center mob-m-tb-pg-3 w-100">
                    <div class="d-flex">
                      <div class="ms-check-box-font-400">
                        {{ i + 1 }}
                      </div>
                    </div>
                    <div class="d-flex flex-wrap w-100">
                      <div *ngIf="editGoalIndex != i" class="ms-check-box-name">
                        {{ goal }}
                      </div>
                      <input
                        *ngIf="editGoalIndex == i"
                        type="text"
                        [(ngModel)]="updateGoalText"
                        class="form-control ms-input-white"
                        placeholder="Goal"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                      />
                    </div>
                  </div>
                  <div class="d-flex mob-m-tb-pg-3" *ngIf="editGoalIndex != i">
                    <div class="circle-btn" (click)="deleteGoal(i)">
                      <i class="fa fa-trash"></i>
                    </div>
                    <div
                      class="circle-btn"
                      (click)="editGoalIndex = i; updateGoalText = goal"
                    >
                      <i class="fa fa-pencil"></i>
                    </div>
                  </div>
                  <div
                    *ngIf="editGoalIndex == i"
                    class="ms-plus-btn mx-2"
                    (click)="updateGoal()"
                  >
                    <i class="pi pi-check"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-12">
          <div class="grey-box">
            <div class="d-flex align-items-end">
              <div class="column width-100">
                <h5 class="medium-h my-2">{{ "Responsible" | translator }}</h5>
              </div>
              <div class="ms-plus-btn mx-2" (click)="changeTopData()">
                <i class="pi pi-plus-circle"></i>
              </div>
            </div>
            <div class="d-flex w-100" style="margin: 3rem 0 -2rem 0">
              <div class="w-100 d-flex flex-row">
                <div class="medium-h my-2" style="padding-right: 1.5rem">#</div>
                <div class="medium-h my-2" style="padding-right: 2.2rem">
                  {{ "Name" | translator }}
                </div>
              </div>
              <div class="medium-h my-2" style="width: 24.3rem">
                {{ "Senior" | translator }}
              </div>
            </div>
            <div class="ms-my-top-bottom-5">
              <div
                class="white-box-check"
                *ngFor="let responsible of project.responsibles; let i = index"
              >
                <div class="custom-flex-pg-3">
                  <div class="d-flex align-items-center mob-m-tb-pg-3 w-100">
                    <div class="d-flex">
                      <div class="ms-check-box-font-400">
                        {{ i + 1 }}
                      </div>
                    </div>
                    <div class="d-flex flex-wrap w-100">
                      <div class="ms-check-box-name">
                        {{ extractUsername(responsible.user.name) }}
                      </div>
                    </div>
                    <div
                      style="width: 20rem"
                      class="d-flex align-items-center justify-content-start"
                    >
                      <p-radioButton
                        [value]="responsible.user._id"
                        [(ngModel)]="senior"
                        (onClick)="seniorChange($event)"
                      >
                      </p-radioButton>
                    </div>
                  </div>
                  <div class="d-flex mob-m-tb-pg-3" *ngIf="editGoalIndex != i">
                    <div class="circle-btn" (click)="removeResponsible(i)">
                      <i class="fa fa-trash"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between">
      <button class="submmit-btn" (click)="createProject()">
        {{ (isUpdate ? "Update" : "Create") | translator }}
      </button>
    </div>
  </div>
</section>
<p-toast />
<p-messages [(value)]="messages" [enableService]="false"></p-messages>
<p-dialog
  [header]="'Add Channel' | translator"
  [(visible)]="showAddChannel"
  [style]="{ width: '95vw', maxWidth: '1000px' }"
>
  <ng-template pTemplate="body">
    <div class="column width-100">
      <h5 class="medium-h my-2">{{ "Channel Name" | translator }}</h5>
      <input
        type="text"
        [(ngModel)]="channelNameText"
        class="form-control ms-input-white"
        placeholder="Channel"
        id="exampleInputEmail1"
        aria-describedby="emailHelp"
      />
    </div>
    <span class="my-2" style="color: red">{{ channelErrorTest }}</span>
  </ng-template>
  <ng-template pTemplate="footer">
    <button class="submmit-btn" (click)="addChannel()">
      {{ "Create" | translator }}
    </button>
  </ng-template>
</p-dialog>

<app-footer></app-footer>
